// @ts-ignore
import * as SDK from "mirrorfly-sdk";

export function getFirstAndLastInitials(name: string) {
  const words = name.split(' ').filter(word => word.length > 0);

  if (words.length === 0) {
    return '';
  }

  const firstInitial = words[0].charAt(0).toUpperCase();
  const lastInitial = words[words.length - 1].charAt(0).toUpperCase();

  return firstInitial + lastInitial;
}

const getAllRegisteredUserInPlatform = async () => {
  const response: any = await SDK.getUsersList(``, 1, 1000);
  return response;
};

const getUserMessages = async (userJid: any) => {
  const response: any = await SDK.getChatMessages({
    toJid: userJid,
    position: "top",
    // lastRowId: "",
    // limit: "",
    // topicId: "",
  });

  return response;
};

// const downloadMediaMessages = async (msgId: any) => {
//   const response: any = await SDK.downloadMedia(msgId,
//     onPending((msgId: any) => {
//       console.log(msgId, "pendingg");
//     }),
//     onSuccess((response: any) => {
//       console.log(response, "responseSucess");
//       return response;
//     }),
//     onError((error: any) => {
//       console.log(error, "error");
//       return error;
//     })
//   );

//   console.log(response, "responseresponse")
//   return response;
// };

const downloadMediaMessages = async (msgId: any) => {
  return new Promise<any>((resolve, reject) => {
    SDK.downloadMedia(
      msgId,
      onPending((msgId: any) => {
        // console.log(msgId, "pending");
      }),
      onSuccess((response: any) => {
        // console.log(response, "responseSuccess");
        resolve(response); // Resolve the promise when successful
      }),
      onError((error: any) => {
        // console.log(error, "error");
        reject(error); // Reject the promise if an error occurs
      })
    );
  });
};



const updateSeenStatusOfMessage = async (messageList: any, userJid: any) => {
  // console.log(userJid, messageList, "djdjjdj")
  const response: any = await SDK.sendSeenStatus(
    userJid,
    messageList[messageList?.length - 1]?.msgId
  );
  return response;
};

const getUserLastScene = async () => {
  const response: any = await SDK.getLastSeen(`TO_USER_JID`);
  return response;
};

const getUserProfileDetails = async (userId: any) => {
  const response: any = await SDK.getUserProfile(userId);
  if (response?.statusCode === 200) {
    return response?.data;
  }
};

const getRegisteredUserList = async (
  searchKey: any,
  pageNo: any,
  pageSize: any
) => {
  const response: any = await SDK.getUsersList(searchKey, pageNo, 100);
  return response;
};

const getRecentChattedUserList = async () => {
  const response: any = await SDK.getRecentChats();
  return response;
};

const getUserJid = async (userId: any) => {
  const response: any = await SDK.getJid(userId);
  return response;
};

const sendTextMessage = async (userJid: any, messageText: any) => {
  const response: any = await SDK.sendTextMessage({
    toJid: userJid,
    messageText: messageText,
    //   mentionedUsersIds: [],
    //   topicId: "",
    // metaData: {
    //   responseUsetJD: responseUsetJD,
    // },
  });
  return response;
};

const onPending = (msgId: any) => {
  return msgId;
};

const onSuccess = (response: any) => {
  return response;
};

const onError = (error: any) => {
  return error;
};

const sendMediaFileMessage = async (reqBody: any) => {
  const { toJid, messageType, fileMessageParams } = reqBody;

  const data: any = {
    toJid: toJid,
    messageType: messageType,
    fileMessageParams: fileMessageParams,
    // Optional fields
    // replyMessageId: "",
    // mentionedUsersIds: [],
    // topicId: "",
    // metaData: {},
  };

  // Wrapping the SDK call in a promise
  return new Promise((resolve, reject) => {
    try {
      SDK.sendMediaFileMessage(
        data,
        (msgId: any) => {
          onPending(msgId);
        },
        (response: any) => {
          resolve(response);  // Resolve the promise on success
          onSuccess(response);
        },
        (error: any) => {
          reject(error);  // Reject the promise on error
          onError(error);
        }
      );
    } catch (error) {
      reject(error);
    }
  });
};

const setProfileDetails = async (
  fullName: string,
  profilePic: any,
  phoneNumber: any,
  email: any
) => {
  const response: any = await SDK.setUserProfile(
    fullName,
    profilePic,
    "Active",
    phoneNumber,
    email
  );
  return response;
};

const muteChat = async (jidToMute: string, isMute: boolean) => {
  const response: any = await SDK.updateMuteNotification(jidToMute, isMute);
  // console.log("response", response);
  return response;
};

// create group methods

const getGroupJid = async (groupId: any) => {
  const response: any = await SDK.getGroupJid(groupId);
  return response;
};

const createGroup = async (
  groupName?: any,
  userIdArray?: any,
  groupImage?: any,
  iSHISTORYON?: boolean
) => {
  const response: any = await SDK.createGroup(
    groupName,
    userIdArray,
    groupImage,
    iSHISTORYON
  );
  return response;
};

const setGroupProfileDetails = async (
  groupJid: any,
  groupName: any,
  groupImage: any,
) => {
  const response = await await SDK.setGroupProfile(
    groupJid,
    groupName,
    groupImage,
  );
  return response;
};

const getGroupsDetails = async () => {
  const response: any = await SDK.getGroupsList();
  return response;
};

const getGroupProfileDetails = async (groupJid: any) => {
  const response: any = await SDK.getGroupProfile(groupJid);
  // console.log(response, "line1866", groupJid)
  return response;
};

const getGroupParticipants = async (groupJid: any) => {
  const response: any = await SDK.getGroupParticipants(groupJid);
  return response;
};

const getGroupChatMessages = async (
  groupJid: any,
  position: string,
  pageNo: any,
  pageSize: any
) => {
  const response: any = await SDK.getChatMessages(
    groupJid,
    position,
    pageNo,
    pageSize
  );
  return response;
};

const addParticipantToGroup = async (
  groupJid: any,
  groupName: any,
  userId: any
) => {
  const response: any = await SDK.addParticipants(groupJid, groupName, userId);
  return response;
};

const removeParticipantFromGroup = async (
  groupJid: any,
  userId: string,
  isAdmin: any
) => {
  const response: any = await SDK.removeParticipant(groupJid, userId, isAdmin);
  return response;
};

const exitUserFromGroup = async (
  groupJid: any,
  userId: string,
  isAdmin: any
) => {
  const response = await SDK.userExitGroup(groupJid, userId, isAdmin);
  return response;
};

const delereGroup = async (groupJid: any) => {
  const response: any = await SDK.userDeleteGroup(groupJid);
  return response;
};

const convertIdToJid = (userId: any, type: string) => {
  if (type === "chat") {
    return `${userId}@sekerontechnolo-xmpp.mirrorfly.com`;
  } else {
    return `${userId}@mix.sekerontechnolo-xmpp.mirrorfly.com`;
  }
};

export {
  SDK,
  getAllRegisteredUserInPlatform,
  // single chat
  getUserMessages,
  downloadMediaMessages,
  updateSeenStatusOfMessage,
  getUserLastScene,
  getUserProfileDetails,
  getRegisteredUserList,
  getUserJid,
  sendTextMessage,
  getRecentChattedUserList,
  sendMediaFileMessage,
  setProfileDetails,
  muteChat,
  // create group
  getGroupJid,
  createGroup,
  setGroupProfileDetails,
  getGroupsDetails,
  getGroupProfileDetails,
  getGroupParticipants,
  getGroupChatMessages,
  addParticipantToGroup,
  removeParticipantFromGroup,
  exitUserFromGroup,
  convertIdToJid,
  delereGroup,
};
